import { WebContext as RebootContext } from "@reboot-dev/reboot-web";

// TODO: sort out the reboot-differential generated code as a library
//       so that we don't have to disable this warning
// eslint-disable-next-line @nx/enforce-module-boundaries -- Imports of apps are forbidden
import {
	Store as RebootStore,
	TableChangesResponse,
	TablePermission as TablePermissionProto,
	Tuple as TupleProto,
} from "@moment/reboot-differential";

type RebootInstance = {
	context: RebootContext;
	store: RebootStore.WeakReference;
};

export {
	RebootContext,
	RebootStore,
	type RebootInstance,
	TableChangesResponse,
	TablePermissionProto,
	TupleProto,
};
